import { getTxtIdMapperPath } from "../../router/txtIdMapper"
import { apiS_withoutToken } from "./api-base"
import { getESGReqHeader } from "./tool-service"


export const queryGSAiHelper = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0000401'),
        ReqBody: reqBody
    }
    return await apiS_withoutToken({ url: `/${getTxtIdMapperPath("F0000401")}`, method: 'post', data: ReqBody })
}